// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.panel-EVLjmk{background:#d3d3d3;width:0;height:100%;transition:width .3s;top:0;overflow:hidden}.panel-EVLjmk.open-jRFZ6M{width:200px}.open-left-KX4AKI{left:0}.open-right-lEUioq{right:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `panel-EVLjmk`,
	"open": `open-jRFZ6M`,
	"open-left": `open-left-KX4AKI`,
	"openLeft": `open-left-KX4AKI`,
	"open-right": `open-right-lEUioq`,
	"openRight": `open-right-lEUioq`
};
export default ___CSS_LOADER_EXPORT___;
